<template>
    <v-tooltip top content-class="arrow-down" v-model="show">
        <template v-slot:activator="{ on, attrs }">
            <div
                class="d-inline-flex"
                v-if="deviceStateData != null"
                v-bind="attrs"
                v-on="on"
                @click="show = true"
            >
                <v-switch
                    v-model="deviceStateData.value"
                    inset
                    dense
                    hide-details
                    class="pa-0"
                    disabled
                ></v-switch>
            </div>
        </template>
        <div class="main-text">
            К сожалению, вы не можете <br> управлять этим устройством
            <span v-if="notFree"> <br> номер занят </span>
        </div>
    </v-tooltip>
</template>

<script>
export default {
    name: "DeviceSwitchDisabled",
    props: {
        deviceState: {
            type: [Array, Object],
            default: null,
        },
        name: {
            type: String,
            default: null,
        },
        notFree: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            deviceStateData: {},
            deviceName: null,
            show: false,
            top: -1,
        };
    },
    mounted() {
        this.deviceStateData = JSON.parse(JSON.stringify(this.deviceState));
        this.deviceName = this.name;
    },
    computed: {
        scroll() {
            return this.$store.state.scrolled;
        },
    },
    watch: {
        scroll(val) {
            if (val != this.top && this.show) {
                this.show = false;
                this.top = -1;
            }
        },
        show(val) {
            if (val) {
                this.top = this.scroll;
            }
        },
        deviceState(val) {
            if (val) {
                this.deviceStateData = JSON.parse(JSON.stringify(val));
            }
        },
    },
}
</script>

<style lang="scss">
.v-tooltip__content {
    background: linear-gradient(180deg, #FFF4BC 0%, rgba(255, 132, 132, 0.8) 100%);
    border-radius: 30px;
    padding: 16px;

    &.menuable__content__active {
        opacity: 1;

        &.arrow-down {
            overflow: inherit !important;
            z-index: 7;

            &::before {
                content: '';
                position: absolute;
                left: 55%;
                top: 100%;
                border: 5px solid #FF8484;
                border-color: #FF8484 transparent transparent transparent;
                opacity: 0.8;
            }
        }
    }
}
</style>